// A lazily loaded page whose script no longer exists (a deploy replaced the
// hashed chunk, or the dev server re-optimised its dependencies) rejects its
// import for good: React.lazy caches the rejection, so "retry" cannot recover.
// Reloading fetches the current chunk list. One reload per session guards
// against a loop when the failure is real.

const RELOAD_FLAG = 'stale-chunk-reloaded'

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error)
  return /dynamically imported module|importing a module script failed|ChunkLoadError/i.test(
    message
  )
}

/** Reload once to pick up the current chunks; false when that was already tried. */
export function reloadForStaleChunk(): boolean {
  try {
    if (sessionStorage.getItem(RELOAD_FLAG)) return false
    sessionStorage.setItem(RELOAD_FLAG, '1')
  } catch {
    return false
  }
  window.location.reload()
  return true
}

export function installStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForStaleChunk()) event.preventDefault()
  })
}
